var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kb-sidebar"},[_c('div',{staticClass:"kb-category-menu"},[_c('ul',_vm._l((_vm.categoryList),function(category){return _c('SidebarItem',{key:category.id,attrs:{"category":category}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }